module.exports = __webpack_public_path__ + "img/suojasatama_original.cfc7de31.jpg";